import * as Yup from "yup";
import { joiEmailSchema } from "../../utils/utils";

export interface QuoteFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  services: any[];
  message: string;
}

export const initialValues: QuoteFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  services: [],
  message: "",
};

const tlds = ["com", "org", "net", "in", "io", "app", "co"];
const tldRegex = new RegExp(
  `^[^\\s@]+@[^\\s@]+\\.(${tlds.join("|")})(\\.[A-Za-z]{2,})?$`,
  "i"
);

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
    .max(50, "First name must be at most 50 characters")
    .required("First Name is required"),
  lastName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
    .max(50, "Last name must be at most 50 characters")
    .required("Last Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .max(150, "Email must be at most 150 characters")
    .matches(tldRegex, "Invalid email address")
    .test("joi-email-check", "Invalid email format", function (value) {
      if (!value) return false;
      const { error } = joiEmailSchema.validate(value);
      return !error;
    })
    .required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^\d+$/, "Only numbers allowed")
    .min(10, "Must be at least 10 digits")
    .required("Phone Number is required"),
  services: Yup.array().min(1, "Select at least one service"),
  message: Yup.string().max(200, "Max 200 characters allowed").nullable(),
});
